<template>
  <el-dialog
  :visible="dialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span v-if="!isEditionMode" class="title" >{{$t('adjustments.newAdjustment')}}</span>
    <span v-if="isEditionMode" class="title" >{{$t('adjustments.editAdjustment')}}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
      <el-form label-position="top" label-width="100px" :model="inventoryAdjustment" :rules="rules" ref="adjustmentForm">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Mode d'ajustement">
              <el-radio :value="adjustment.mode" :label="0">Quantité</el-radio>
              <el-radio v-model="adjustment.mode" :label="1" :disabled="true">Valeur</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Reference">
              <el-input placeholder="Numéro de référence" v-model="reference"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Date effective" prop="date">
              <el-date-picker
                v-model="inventoryAdjustment.date"
                type="date"
                placeholder="Choississez ue date"
                @change="setDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Lot" prop="item">
              <el-select v-model="inventoryAdjustment.item" placeholder="Select" value-key="id" @change="setItem">
                <el-option
                  v-for="item in adjustedProduct.items"
                  :key="item.id"
                  :label="getItemLabel(item)"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="adjustedProduct.item">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item label="Quantité disponible">
              <el-input v-if="adjustedProduct!=null && adjustedProduct.item!=null" :value="adjustedProduct.item.quantity.on_hand" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item label="Quantité ajustée">
              <el-input-number v-model="adjusted_qty" :controls="false"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item label="Ajustement" prop="diff">
              <el-input-number v-model="inventoryAdjustment.diff" @change="setDiff"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Raison" prop="reason">
              <el-select v-model="inventoryAdjustment.reason" placeholder="Select" value-key="id" @change="setReason">
                <el-option
                  v-for="item in reasons"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="Description">
              <el-input type="textarea" :rows="4"  v-model="description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </el-row>

  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="close">Annuler</el-button>
    <el-button type="primary" @click="save">Enregistrer</el-button>
  </span>
</el-dialog>
</template>
<script>

import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'InventoryAdjustment',
	props: {
    product : null,
    productItems : null,
		dialogVisible : Boolean,
    editSelectedAdjustment : {
      type : Boolean,
      default : false
    },
    inventoryId : Number
	},
  data() {
    return {
      inventoryAdjustment : {
        date : null,
        reason : null,
        diff : null,
        item : null,
      },
      rules : {
  	  	date : [
  	  		 	{ required: true, message: 'Veuillez saisir une date', trigger: 'blur' }
  	  		],
        reason : [
          	{ required: true, message: 'Veuillez sélectionner une raison', trigger: 'blur' }
        ],
        diff : [
  	  		 	{ required: true, message: 'Veuillez saisir une valeur', trigger: 'blur' }
  	  		],
        item : [
          { required: true, message: 'Veuillez saisir un lot à ajuster', trigger: 'blur' }
        ]
  	  },
      fullScreenLoading : false,
    };
  },components: {

  },
	methods: {
    setReason(reason){
      this.setAdjustmentProp({reason})
    },
    setItem(item){
      this.setAdjustedProductItem(item)
    },
    setDiff(diff){
      this.setAdjustedProductQuantity({diff})
    },
    getItemLabel(item){
      let label =  this.moment(item.availability_date);
      if(item.reference!=null && item.reference!=""){
        label+=" - " + item.reference;
      }
      return label;
    },
    moment(datetime){
			return  moment(datetime).format('LL');
		},
    setDate(effective_date){
      this.setAdjustmentProp({effective_date})
    },
    open(){
      let initParams = {};
      if(this.product!=null){
        initParams.onProduct = true;
        initParams.product = this.product;
        initParams.productItems  = this.productItems;
        initParams.inventoryId = this.inventoryId;
      }
      // console.log(initParams);
      this.initAdjustment(initParams);
      this.fetchReasons();

    },
    close(){
       this.reset();
       this.$refs['adjustmentForm'].resetFields();
       this.$emit('close');
    },
    save(){

      this.$refs['adjustmentForm'].validate((valid)=>{
        if(valid){
          this.postAdjustment()
            .then(response=>{
              this.fetchAdjustments({productId:this.product.id, inventoryId : this.inventoryId});
              this.$emit('adjusted');
              this.close();
              this.$message({
                message: "L'ajustement d'inventaire a été sauvegardé avec succès!",
                type: 'success'
              });
            })
        }else{
          this.$notify({
              title: 'Avertissement',
              message: "Certains champs obligatoires n'ont pas été renseignés.",
              type: 'warning'
            });
        }
      })

    },
    ...mapActions('inventoryAdjustmentEditor',['fetchReasons', 'reset','setAdjustmentProp', 'initAdjustment','setAdjustedProductQuantity','setAdjustedProductItem','postAdjustment']),
    ...mapActions('inventoryAdjustment',['fetchAdjustments'])
	},
	computed: {
    reference : {
      set(reference){this.setAdjustmentProp({reference})},
      get(){return this.adjustment.reference}
    },
    description : {
      set(description){this.setAdjustmentProp({description})},
      get(){return this.adjustment.description}
    },
    adjusted_qty : {
      set(adjusted_qty){this.setAdjustedProductQuantity({adjusted_qty})},
      get(){return this.adjustedProduct.adjusted_qty}
    },
    isEditionMode(){
      return this.editSelectedAdjustment;
    },
    ...mapState('inventoryAdjustmentEditor',['adjustment', 'reasons','adjustedProduct'])
	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}

.formContainer{
    margin-left:25%;
    width:50%;
  }

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
